export function selectCurrentPatientInfo(state: Store) {
  return state.waitingRoomReducer.currentPatientInfo
}

export function selectProviderId(state: Store): string | undefined {
  return state.waitingRoomReducer.providerProfile?.ProviderId
}
